<template>
  <div class="col-12">
    <div class="card activity-item">
      <div class="card-body">
        <div class="activity-icon">
          <div class="icon-bg">
            <i :class="'material-icons ' + message.cautionLabel">
              {{ message.materialIcon }}
            </i>
          </div>
        </div>
        <div class="activity-content">
          <h4>{{ message.head }}</h4>
          <p>{{ message.body }}</p>
        </div>
        <div class="activity-timestamp">
          {{ timestamp | time }}
          <span v-if="timedeltaDays">(+{{ timedeltaDays }}d)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import baseController from '../../controllers/base'

export default {
  extends: baseController,
  props: ['message', 'timestamp', 'oldestTimestamp'],
  computed: {
    timedeltaDays() {
      return moment(this.timestamp).days() - moment(this.oldestTimestamp).days()
    }
  }
}
</script>
